export default __webpack_public_path__ + "static/reading-en@2x-8e0c3dad1778d5e8595ee565c80c5c06.png";